module.exports = __webpack_public_path__ + "img/search.7d841ae0.svg";